import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth-guard';
import { NoAuthGuard } from './core/guards/noauth-guard';
import { PasswordChangeGuard } from './core/guards/password-change-guard';
import { Authredirect } from './core/components/authredirect/authredirect';

const routes: Routes = [
  {
    path: '',
    component: Authredirect,
  },
  {
    path: 'login',
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./auth/auth-module').then((m) => m.AuthModule),
  },
  {
    path: 'cambiar-password',
    canActivate: [PasswordChangeGuard],
    loadChildren: () =>
      import('./auth/cambiar-password/cambiar-password-module').then(
        (m) => m.CambiarPasswordModule,
      ),
  },
  {
    path: 'registro-pci',
    canActivate: [NoAuthGuard],

    loadChildren: () =>
      import('./auth/registro-pci/registro-pci-module').then(
        (m) =>
          m.RegistroPciModule,
      ),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard-module').then((m) => m.DashboardModule),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
